const SettingsSection = ({title, children}) => (
    <div>
        <div className='text-xs mb-1 px-1 font-medium text-gray-500'>{title}</div>
        <div className='divide-y divide-gray-200 overflow-hidden rounded-lg bg-gray-50'>{children}</div>
    </div>
);

export default SettingsSection;
